<template>
    <div class="templete_box">
        <div class="templete">
            <!-- <div class="header_row clearfix">
                <div class="header_row_message">
                    <span>供应商：{{info.supplier}}</span>
                    <span>合同号：{{info.contract_no}}</span>
                    <span>提单号：{{info.bill_lading_no}}</span>
                </div>
                <div class="header_row_return">
                    返回列表
                </div>
            </div> -->
            <div class="search_box search_box_f clearfix">
                <el-input class="search_input search_inputBox" v-model="params.bale_no" placeholder="捆包号"></el-input>
                <el-select class="search_select search_inputBox" v-model="params.bale_status" multiple collapse-tags placeholder="资源状态" @visible-change="getSelectTranslateDetailList('bale_status')">
                    <el-option v-for="list in selectMapC.bale_status" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.breed_id" multiple collapse-tags placeholder="品名" @visible-change="getSelectTranslateDetailList('breed_id')">
                    <el-option v-for="list in selectMapC.breed_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.brand_id" multiple collapse-tags placeholder="品牌" @visible-change="getSelectTranslateDetailList('brand_id')">
                    <el-option v-for="list in selectMapC.brand_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.grade_id" multiple collapse-tags placeholder="等级" @visible-change="getSelectTranslateDetailList('grade_id')">
                    <el-option v-for="list in selectMapC.grade_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.index_thickness" multiple collapse-tags placeholder="厚度" @visible-change="getSelectTranslateDetailList('index_thickness')">
                    <el-option v-for="list in selectMapC.index_thickness" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.index_length" multiple collapse-tags placeholder="长度" @visible-change="getSelectTranslateDetailList('index_length')">
                    <el-option v-for="list in selectMapC.index_length" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <!-- <el-input class="search_input search_inputBox" v-model="params.thickness" placeholder="厚度"></el-input>
                <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.length" placeholder="长度"></el-input> -->
                <el-select class="search_select search_inputBox" v-model="params.supplier_id"  collapse-tags  placeholder="供应商" @visible-change="getSelectTranslateDetailList('supplier_id')">
                    <el-option v-for="list in selectMapC.supplier_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-if="isShowMore"  v-model="params.attribute_id" multiple collapse-tags placeholder="属性"  @visible-change="getSelectTranslateDetailList('attribute_id')">
                    <el-option v-for="list in selectMapC.attribute_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.color_id" multiple collapse-tags placeholder="选色" @visible-change="getSelectTranslateDetailList('color_id')">
                    <el-option v-for="list in selectMapC.color_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.contract_no" placeholder="合同号" size="mini"></el-input>
                <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.bill_lading_no" placeholder="提单号"></el-input>
                <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.container_no" placeholder="货柜号" size="mini"></el-input>
                <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.warehouse_id"  multiple collapse-tags placeholder="仓库" @visible-change="getSelectTranslateDetailList('warehouse_id')">
                    <el-option v-for="list in selectMapC.warehouse_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <div class="search_time search_inputBox" v-if="isShowMore">
                    <el-date-picker v-model="inbound_time_start" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="开始日期"></el-date-picker>
                    ~
                    <el-date-picker v-model="inbound_time_end" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束日期"></el-date-picker>
                </div>
                <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.opening_company_id" placeholder="货权单位" @visible-change="getSelectTranslateDetailList('opencompany')">
                    <el-option v-for="list in selectMap.opencompany" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.bill_lading_no" placeholder="备注"></el-input>

                <div class="searchBtnList clearfix">
                    <div class="reset fcolor" @click="isShowMore=!isShowMore">{{isShowMore?'收起':'更多'}}</div>
                    <div class="reset fcolor" @click="reset">重置</div>
                    <el-button  class="publicBtn" @click="getDetailList()">查询</el-button>
                </div>
                <div class="execlInsert execlInsertHasFilter clearfix">
                    <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                    <span class="excel_btn" @click="excelExport"><i class="excel-icon"></i>excel导出</span>
                </div>
            </div>
            <div class="btnList clearfix">
                <el-button class="funcPublicBtn" @click="openAdd">添加单条数据</el-button>
                <el-button class="funcPublicBtn" @click="batchEdit">批量修改</el-button>
                <el-button class="funcPublicBtn" @click="batchDel">批量删除</el-button>
                <el-button class="funcPublicBtn" @click="openbusinessRelation">关联加工费用</el-button>
                <el-button class="funcPublicBtn" @click="confirmReceiptOpen">确认入库</el-button>
                <el-button class="funcPublicBtn" v-if="module.includes(',warehouse-statistic-label,')" @click="printTip">标签</el-button>
                <div class="execlInsertBtnC execlInsertHasFilter clearfix">
                    <span class="excel_btn" @click="openimport()"><i class="excel-icon"></i>EXECL码单导入</span>
                </div>
                <div class="header_row_return" @click="backList">
                    返回列表
                </div>
                <div class="upimgBtnBox" v-if="module.includes(',inventory-upload-files,')" @click="bacthUpFile">
                    <div class="upFileBtnImg"></div>
                    <div class="upimgBtnTitle">上传文件</div>
                </div>
                <div class="upimgBtnBox" v-if="module.includes(',inventory-upload-images,')" @click="bacthUpImg">
                    <div class="upimgBtnImg"></div>
                    <div class="upimgBtnTitle">上传图片</div>
                </div>
            </div>
            <div class="tableBox">
                <tabletem :isSetCol="true" scene="translate.detail.list" :isLoading="tableLoading" @relativefile="relativeFile" :tablecol="tableCol" :tabledata="list" @getRow="getRow" @getTableDelete="getTableDelete" @getTableSee="getTableSee" @getTableEdit="getTableEdit" @rowClick="rowClick"></tabletem>
            </div>
            <div class="totalCal">
                <div class="totalName">合计：</div>
                <div class="totalNumber" v-if="totalObj.numbers||Number(totalObj.numbers)==0">件数:{{totalObj.numbers}}</div>
                <div class="totalNumber" v-if="totalObj.cube_total||Number(totalObj.cube_total)==0">立方:{{totalObj.cube_total}}</div>
                <div class="totalNumber" v-if="totalObj.purchase_amount||Number(totalObj.purchase_amount)==0">采购金额:{{totalObj.purchase_amount}}</div>
                <div class="totalNumber" v-if="totalObj.fee_amount||Number(totalObj.fee_amount)==0">费用金额:{{totalObj.fee_amount}}</div>
                <div class="totalNumber" v-if="totalObj.cost_amount||Number(totalObj.cost_amount)==0">成本金额:{{totalObj.cost_amount}}</div>
                <div class="totalNumber">选中件数: {{selectRow.length}}</div>
                <div class="totalNumber">选中立方: {{selectCube}}m³</div>
            </div>
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" @rowClick="rowClick" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
        </div>

        <el-dialog v-dialog-drag :visible.sync="dialogVisible" class="eldialog eldialogA" width="630px" :modal="false" :title="detailType==2?'新增数据':'修改数据'" custom-class="full_dialog">
            <!-- <div class="btnList clearfix" v-if="detailType==2" style="padding-bottom:10px;">
                <el-button :class="['funcPublicBtn',category==1?'funcPublicBtnChecked':'']" @click="category=1;detailObject.category=1;">非洲材</el-button>
                <el-button :class="['funcPublicBtn',category==2?'funcPublicBtnChecked':'']" @click="category=2;detailObject.category=2;">北美材</el-button>
            </div> -->
            <el-form :rules="batchEditType==2?detailObjectRules:detailObjectRulesBatch" ref="detailObjectForm" :model="detailObject" class="clearfix">
                <div class="eldialogFormBox">
                    <el-form-item  label="类型：" prop="category" >
                        <el-select v-model="detailObject.category" filterable>
                            <el-option v-if="boardAmericaType" :value="1" :label="'北美材'"></el-option>
                            <el-option v-if="nationalStandardType" :value="2" :label="'非洲材'"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="包号：" prop="bale_no" >
                        <el-input v-model="detailObject.bale_no"></el-input>
                    </el-form-item>
                    <el-form-item  label="品名：" prop="breed_id">
                        <el-select v-model="detailObject.breed_id" @visible-change="getSelectList('breed')">
                            <el-option v-for="list in selectMap.breed" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="厚度：" prop="original_thickness" >
                        <el-input v-model="detailObject.original_thickness" :disabled="detailObject.category==2"></el-input>
                    </el-form-item>
                    <el-form-item  label="品牌：" prop="brand_id">
                        <el-select v-model="detailObject.brand_id" @visible-change="getSelectList('brand')">
                            <el-option v-for="list in selectMap.brand" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="长度：" prop="original_length" >
                        <el-input v-model="detailObject.original_length" :disabled="detailObject.category==2"></el-input>
                    </el-form-item>
                    <el-form-item  label="等级：" prop="grade_id">
                        <el-select v-model="detailObject.grade_id" @visible-change="getSelectList('grade')">
                            <el-option v-for="list in selectMap.grade" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="片数：" v-if="detailObject.category==1" prop="pieces">
                        <el-input v-model="detailObject.pieces"></el-input>
                    </el-form-item>
                    <!-- <el-form-item  label="码单总宽：" v-if="detailObject.category==2" prop="original_width_total">
                        <el-input v-model="detailObject.original_width_total" @click="widthClick()" readonly></el-input>
                    </el-form-item> -->
                    <el-form-item  label="码单总宽：" v-if="detailObject.category==2" prop="original_width_total">
                        <!-- <el-input v-model="detailObject.original_width_total" @click="widthClick()" readonly></el-input> -->
                        <div class="formBorder" @click="widthClick()" >
                            <span style="text-decoration:underline;cursor:pointer;">
                                {{detailObject.original_width_total}}
                            </span>
                        </div>
                    </el-form-item>
                    <el-form-item  label="属性：" prop="attribute_id">
                        <el-select v-model="detailObject.attribute_id" @visible-change="getSelectList('attribute')">
                            <el-option v-for="list in selectMap.attribute" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="码单立方：" prop="original_cube" >
                        <el-input v-model="detailObject.original_cube" :disabled="detailObject.category==2"></el-input>
                    </el-form-item>
                    <el-form-item  label="选色：" prop="color_id">
                        <el-select v-model="detailObject.color_id" @visible-change="getSelectList('color')">
                            <el-option v-for="list in selectMap.color" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="检尺立方："  v-if="detailObject.category==1" prop="check_cube">
                        <el-input v-model="detailObject.check_cube"></el-input>
                    </el-form-item>
                    <el-form-item  label="销售总宽："  v-if="detailObject.category==2"  prop="sales_width_total">
                        <!-- <el-input v-model="detailObject.sales_width_total" readonly></el-input> -->
                        <div class="formBorder" @click="salesWidthClick()" > 
                            <span style="text-decoration:underline;cursor:pointer;">
                                {{detailObject.sales_width_total}}
                            </span>
                        </div>
                    </el-form-item>
                    <el-form-item  label="供应商：" prop="supplier_id" >
                        <el-select v-model="detailObject.supplier_id"  @visible-change="getSelectList('supplier')" filterable>
                            <el-option v-for="list in selectMap.supplier" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="销售立方：" prop="sales_cube" >
                        <el-input v-model="detailObject.sales_cube" :disabled="detailObject.category==2"></el-input>
                    </el-form-item>
                    <!-- <el-form-item  label="合同号：" prop="contract_no">
                        <el-input v-model="detailObject.contract_no"></el-input>
                    </el-form-item> -->
                    <el-form-item  label="采购单价：" prop="cube_price">
                        <el-input v-model="detailObject.cube_price"></el-input>
                    </el-form-item>
                    <el-form-item  label="提单号：" prop="bill_lading_no">
                        <el-input v-model="detailObject.bill_lading_no"></el-input>
                    </el-form-item>
                    <el-form-item  label="挂牌价：" prop="sales_price">
                        <el-input v-model="detailObject.sales_price"></el-input>
                    </el-form-item>
                    <el-form-item  label="货柜号：" prop="container_no" >
                        <el-input v-model="detailObject.container_no"></el-input>
                    </el-form-item>
                    <el-form-item  label="备注：" prop="remark" >
                        <el-input v-model="detailObject.remark"></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn" @click="add">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="dialogVisible=!dialogVisible">关闭</el-button>
            </div>
        </el-dialog>
        <!-- <div class="statistics">
            <span>合计：</span>
            <span>$外币总金额：312312</span>
            <span>￥总金额：312312</span>
        </div> -->
        <!--execl START-->
        <el-dialog v-dialog-drag title="码单导入" :visible.sync="importDialogVisible" class="eldialog eldialogExcel" :modal="false" width='680px'>
			<div class="text-center"  style="margin-top:20px;">
                <div class="tab_box">
                    <div v-if="boardAmericaType" :class="{active: active == 1 }" @click="active=1">北美材成品码单</div>
                    <div v-if="boardAfricaType" :class="{active: active == 3 }" @click="active=3">非洲材成品码单</div>
                    <!-- <div v-if="boardZelkovaType" :class="{active: active == 2 }" @click="active=2">榉木码单模板</div>
                    <div v-if="categoryRawType" :class="{active: active == 4 }" @click="active=4">原木码单模板</div> -->
                    <div v-if="nationalStandardType" :class="{active: active == 5 }" @click="active=5">非洲材/国标成品码单</div>
                </div>
                <div class="text-center relative" style="padding: 80px 150px 65px;">
                    <el-upload class="upload-demo" ref='upload_path' drag :action="oss.host" :data="upload_data" :on-success="handleSuccess" :before-upload="beforeUpload" accept=".xls,.xlsx">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text"  style="font-size:12px; color:#333;">将文件拖到此处，或<em style="color: #b21111;text-decoration: underline;">导入上传码单</em></div>
                        <div class="el-upload__tip" slot="tip"  style="color: #888;margin-top:5px;">只能上传Excel文件</div>
                    </el-upload>
                    <div class="">
                        <el-link type="primary" @click='downTemplete' style="color:#b21111;font-weight:bold; cursor:pointer;text-decoration: underline;">下载码单模板</el-link>
                    </div>
                </div>
			</div>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn" @click="importFile">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="importDialogVisible=!importDialogVisible">取消</el-button>
            </div>
		</el-dialog>
        <!--execl END-->
        <!-- 入库确认框 dialog START -->
        <el-dialog v-dialog-drag title="翻包明细入库确认" :visible.sync="checkoutDialog" class="eldialog eldialogLine" :modal="false" custom-class="full_dialog">
            <el-form :model="form_params" ref="add_form" class="dialogFormB clearfix">
                <div class="eldialogFormBox">
                    <el-form-item label="仓库：">
                            <el-select class="edit_input" v-model="form_params.warehouse_id" @change="inStockWarehouse" @visible-change="getSelectList('warehouse')">
                                <el-option v-for="list in selectMap.warehouse" :key="list.id" :value="list.id" :label="list.name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="库位：">
                            <el-select class="edit_input" v-model="form_params.storage_location_id">
                                <el-option v-for="list in locationList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                            </el-select>
                        </el-form-item>
                    <!-- <el-form-item label="选择仓库：">
                        <el-select  v-model="form_params.warehouse_id" placeholder="仓库"  @visible-change="getSelectList('warehouse')">
                            <el-option v-for="list in selectMap.warehouse" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="库位：:">
                        <el-select class="edit_input" v-model="form_params.storage_location">
                            <el-option v-for="list in locationList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item label="入库时间：">
                        <el-date-picker v-model="form_params.inbound_time" type="date" ></el-date-picker>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn" @click="checkoutDialog=!checkoutDialog">取消</el-button>
                <el-button  class="publicBtn dialogBtn" @click="transferConfirm()">确定</el-button>
            </div>
        </el-dialog>
        <!-- 入库确认框 dialog END -->
          <!--添加费用START-->
          <el-dialog v-dialog-drag :visible.sync="businessRelation" class="eldialog eldialogLine" :modal="false" title="添加成本费用" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <el-form ref="feeOutForm" :model="businessRelationForm" :rules="feeOutFormRlues" class="clearfix dialogFormB">
                    <el-form-item  label="日期：" prop="fee_date">
                        <el-date-picker v-model="businessRelationForm.fee_date"  type="date" placeholder="" size="mini"></el-date-picker>
                    </el-form-item>
                    <el-form-item  label="费用名称：" prop="fee_id">
                        <el-select v-model="businessRelationForm.fee_id" @input="outFeeChange" @visible-change="outFeeSelectFunc" clearable>
                            <el-option v-for="list in outFeeSelect" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="收款人(单位)：" prop="payee">
                        <el-input v-model="businessRelationForm.payee"></el-input>
                    </el-form-item>
                    <el-form-item  label="费用金额(￥)：" prop="amount">
                        <el-input v-model="businessRelationForm.amount"></el-input>
                    </el-form-item>
                    <el-form-item  label="提供发票：" prop="is_invoice">
                        <el-select v-model="businessRelationForm.is_invoice">
                            <el-option value="1" label="是"></el-option>
                            <el-option value="0" label="否"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="备注：" prop="remark">
                        <el-input v-model="businessRelationForm.remark"></el-input>
                    </el-form-item>
                    <div class="elFormBoxBtnListCol">
                        <el-button class="funcPublicBtn" @click="businessRelation=!businessRelation" style="margin-right:15px!important;">取消</el-button>
                        <el-button class="funcPublicBtn funcPublicBtnChecked"  @click="newOutFee">确认</el-button>
                    </div>
                </el-form>
            </div>
        </el-dialog>
        <!--添加费用END-->
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" scene="translate.detail.list" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
       <!-- 宽度列表START -->
       <el-dialog v-dialog-drag :visible.sync="dialogVisibleWidth" class="eldialog totalWidthDialog" width="820px" :modal="false" custom-class="full_dialog">
            <total-widthnew :edit="isCanWidthEdit" :isHidePer="isHidePer" :ispost="ispost" :issetper="issetper" :widthSaleInventoryId="widthSaleInventoryId" :dialogvisible="dialogVisibleWidth" :type="widthObj.widthType" :widthid="widthObj.id" :list="widthObj.widthList" @changeSuccess="getDetailList" @cancelWidth="()=>{this.dialogVisibleWidth = false;}"></total-widthnew>
        </el-dialog>
        <!-- 宽度列表END -->
         <!-- 销售宽度列表START -->
         <el-dialog v-dialog-drag :visible.sync="saleDialogVisibleWidth" class="eldialog totalWidthDialog" width="820px" :modal="false" custom-class="full_dialog">
            <total-widthnew :edit="isSaleCanEditTotalWidth" :dialogvisible="saleDialogVisibleWidth" :list="widthObj.widthList" @returnwidth="res=>{saleWidthReturn(res)}" :type="1"  @cancelWidth="()=>{this.saleDialogVisibleWidth = false;}"></total-widthnew>
        </el-dialog>
        <!-- 销售宽度列表END -->
        <!-- 宽度列表START -->
         <el-dialog v-dialog-drag :visible.sync="dialogVisibleWidthA" class="eldialog totalWidthDialog" width="820px" :modal="false" custom-class="full_dialog">
                <total-widthnew :edit="isCanEditTotalWidth" :dialogvisible="dialogVisibleWidthA" :list="widthList"  @returnwidth="res=>{widthReturn(res)}" @cancelWidth="()=>{this.dialogVisibleWidthA = false;}"></total-widthnew>
        </el-dialog>
         <!-- 宽度列表END -->
        <!-- 销售宽度列表START -->
        <el-dialog v-dialog-drag :visible.sync="saleDialogVisibleWidthA" class="eldialog totalWidthDialog" width="820px" :modal="false" custom-class="full_dialog">
            <total-widthnew :edit="isSaleCanEditTotalWidth" :dialogvisible="saleDialogVisibleWidthA" :list="widthList" @returnwidth="res=>{saleWidthReturn(res)}" :type="1"  @cancelWidth="()=>{this.saleDialogVisibleWidthA = false;}"></total-widthnew>
        </el-dialog>
        <!-- 销售宽度列表END -->
        <!-- 图片上传 START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleImg" class="eldialog eldialogOneLabel accountDialog" width="500px" :modal="false" title="图片上传" custom-class="full_dialog">
            <div class="upimgOutBox clearfix">
                <div class="upImgBox" v-for="(item,index) in upImagesList" :key="index+'_index'">
                    <img src="/icon/top-delete-suspension.png" class="upImgRemove" @click="upImgRemove(item)"/>
                    <img :src="item" class="upImg"/>
                </div>
                <el-upload class="upload-demo" ref='upload_path' drag multiple :action="oss.host" :data="upload_data" :on-success="handleImagesSuccess" :before-upload="beforeUpload" accept=".png,.jpg,.jpeg,.PNG,.JPG,.JPEG">
                    <img src="/icon/addProductImg.png" class="uploadImageAdd">
                </el-upload>
            </div>
            <div class="dialogBtnList clearfix">
                <el-button  class="funcPublicBtn funcPublicBtnChecked dialogBtn" @click="saveImgs">保存</el-button>
                <el-button class="funcPublicBtn dialogBtn" @click="dialogVisibleImg = false">关闭</el-button>
            </div>
        </el-dialog>
        <!-- 图片上传 END -->
        <!-- 文件上传 START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleFile" class="eldialog eldialogOneLabel eldialogFileUpload" width="500px" :modal="false" title="文件上传" custom-class="full_dialog">
            <div class="upFileOutBox clearfix">
                <el-upload class="upload-demo" ref='upload_path' drag :action="oss.host" :data="upload_data" :on-success="handleSuccessB" :before-upload="beforeUpload">
                    <img src="/icon/upfile.png" class="uploadFileAdd">
                    <div class="uploadTitle">点击文件上传</div>
                </el-upload>
                <div class="upFileBox clearfix" v-for="(item,index) in upFileList" :key="index+'_index'">
                    <div class="upFile">{{item.name}}</div>
                    <img src="/icon/top-delete-suspension.png" class="upFileRemove" @click="upFileRemove(item.url)"/>
                    <div class="upFileUnder"></div>
                    <div class="upFileTop"></div>
                    <div class="upFileLeft"></div>
                    <div class="upFileRight"></div>
                </div>
            </div>
            <div class="dialogBtnList clearfix">
                <el-button  class="funcPublicBtn funcPublicBtnChecked dialogBtn" @click="saveFile">保存</el-button>
                <el-button class="funcPublicBtn dialogBtn" @click="dialogVisibleFile = false">关闭</el-button>
            </div>
        </el-dialog>
        <!-- 文件上传 END -->
        <relativeFile :dialog="downLoadFileDialog" @closeDialog="()=>{this.downLoadFileDialog = false}" :files="downFilesList"></relativeFile>

    </div>
</template>
<style scoped lang="scss">
    .widthListBox{margin-bottom:10px;
        .title{width:100%;background-color: #e4e4e4;text-align: center;font-size: 13px;color: #777;padding:5px 0;}
        .widthList{padding-right:25px;position: relative;
            .widthsList{display: flex;height:25px;width:100%;
                .widthBox{flex:1;height:25px;position: relative;
                    .widths{width:100%;height: 25px;border:1px solid #e4e4e4;font-size: 12px;line-height: 25px;}
                    .delWidth{width:10px;height:10px;position: absolute;top:0;right:0;background: url('../../assets/top-delete-suspension.png') no-repeat 100% 100%;background-size: 100% 100%;cursor: pointer;}
                }
            }
            .addWidth{width:25px;height:25px;position: absolute;top:0;right:0;background: url('../../assets/addWidth.png') no-repeat 50% 50%;background-size: 70% 70%;cursor: pointer;}
        }
    }
    .header_row{padding:10px 0;}
    .header_row_message{float: left;font-size: 12px;color:#777;
        span{margin-right:10px;}
    }
    .header_row_return{float: right;font-size: 14px;font-weight: 600;}
    .delWidth{width:10px;height:10px;position: absolute;top:0;right:0;background: url('../../assets/top-delete-suspension.png') no-repeat 100% 100%;background-size: 100% 100%;cursor: pointer;}
    .addWidth{position: relative; width:32px;height:32px;float:left;background: url('../../assets/addWidth.png') no-repeat 50% 50%;background-size: 70% 70%;cursor: pointer;}
    .tab_box{
        display: flex; align-items: center; border-bottom: 2px solid #EEEEEE; padding-bottom: 11px;
        & > div{
            width: 150px; text-align: center; padding: 8px 0; border:1px solid #707070; border-radius:3px; cursor: pointer; font-size: 14px;
            & + div{ margin-left: 30px; }
            &.active{ background: #B21111; color: #fff; border:1px solid #B21111; }
        }
    }
    .formBorder{border-radius: 4px;border: 1px solid #DCDFE6;border-color: #a7a7a7;    text-align: initial;padding-left: 10px;font-size: 12px;cursor:pointer;}
    .eldialog.eldialogOneLabel /deep/ .el-form-item .el-form-item__content{width:160px;}

    .upimgOutBox .uploadImageAdd{width:100%;height:100%;}
    .upimgOutBox .uploadImageAdd{width:100%;height:100%;}
    .upimgOutBox .upload-demo{float: left;width:102px;height:102px;overflow: hidden;}
    .upimgOutBox .upImgBox{position: relative;width:102px;height:102px;float: left;margin-right:10px;margin-bottom:10px;position: relative;}
    .upimgOutBox .upImg{display: block;width:100%;height:100%;}
    .upimgOutBox .upImgRemove{width:20px;height:20px;position: absolute;top:5px;right:5px;cursor:pointer;}
</style>
<script>
    import tabletem from '../../components/table.vue'
    import pagination from '../../components/pagination.vue'
    import relativeFile from '../../components/downloadRelativeFile.vue'
    import { number } from 'echarts/lib/export';
    const initBusinessRelationForm = {
        fee_date: "",
        fee_id: "",
        fee_name: "",
        payee: "",
        amount: "",
        is_invoice: "",
        remark: ""
    };
    export default {
        components:{
            tabletem,
            pagination,
            relativeFile
        },
        data(){
            return{
                module:localStorage.dw_erp_power_code,
                tableLoading:false,
                isShowMore:false,
                inbound_time_start:'',
                inbound_time_end:new Date(),
                typeBale:2,//2板材 3原木
                importDialogVisible:false,
                upload_data : {},
				oss : {
                    host : "",
                },
				file_url : '',
                isUpImg:0,
                dialogVisibleImg:false,
                upImgObj:{
                    kid:[],
                    images:[]
                },
                dialogVisibleFile:false,
                upFileObj:{
                    kid:[],
                    files:[]
                },
                upImagesList:[],
                upFileList:[],
                info:{
                    bill_lading_no: "",
                    container_no: "",
                    supplier: "",
                    tpl_code:"",
                    wood_type:"",
                    category:""
                },
                widthList:[],
                tab : 1,
                category:1,//1非洲材, 2北美材
                detailType:2,//2新增 3修改
                batchEditType:2,//2单条修改 3批量修改
                params:{
                    page:1,
                    per_page: 50,
                    bale_no:"",
                    bale_status:'',
                    brand_id:[],
                    breed_id:[],
                    grade_id:[],
                    index_thickness:[],
                    index_length:[],
                    supplier_id:[],
                    attribute_id:[],
                    color_id:[],
                    contract_no:'',
                    bill_lading_no:'',
                    container_no:'',
                    warehouse_id:[],
                    inbound_time_start:'',
                    inbound_time_end:'',
                    opening_company_id:[],
                    remark:'',
                },
                purchase_id:"",
                selectMap:{
                    breed:[],
                    brand:[],
                    grade:[],
                    supplier:[],
                    port:[],
                    color:[],
                    attribute:[],
                    opencompany:[],
                    warehouse:[],
                },
                selectMapC:{
                    bale_status:[],
                    breed_id:[],
                    brand_id:[],
                    grade_id:[],
                    index_thickness:[],
                    index_length:[],
                    supplier_id:[],
                    attribute_id:[],
                    color_id:[],
                    warehouse_id:[],
                    opening_company_id:[],
                },
                dialogVisible:false,
                detailObject:{
                    category:"",
                    brand_id:"",
                    breed_id:"",
                    grade_id:"",
                    purchase_id:"",
                    // contract_no:"",
                    attribute_id:"",
                    color_id:"",
                    supplier_id:"",
                    bill_lading_no:"",
                    container_no:"",
                    bale_no:"",
                    original_thickness:"",
                    original_length:"",
                    pieces:"",//片数 北美材字段
                    original_cube:"",
                    check_cube:"",
                    sales_cube:"",
                    cube_price:"",
                    sales_price:"",
                    original_width_total:0,
                    sales_width_total:0,
                    width:[{
                        cube:'',
                        layer_number: "",
                        length: "",
                        length_formula: "",
                        spec: "",
                        thickness: "",
                        thickness_formula: "",
                        veneer_avg: "",
                        width: [],
                        width_other: "",
                        pieces:'',
                    }],
                    sales_width:[{
                        cube:'',
                        layer_number: "",
                        length: "",
                        length_formula: "",
                        spec: "",
                        thickness: "",
                        thickness_formula: "",
                        veneer_avg: "",
                        width: [],
                        width_other: "",
                        pieces:'',
                    }],
                    remark:"",
                },
                detailObjectRules:{
                    category:[ { required: true, message: '请填写类型', trigger: 'blur' }],
                    bale_no:[ { required: true, message: '请填写包号', trigger: 'blur' }],
                    // contract_no:[ { required: true, message: '请填写合同号', trigger: 'blur' }],
                    grade_id:[ { required: true, message: '请填写等级', trigger: 'blur' }],
                    breed_id:[ { required: true, message: '请填写品名', trigger: 'blur' }],
                    original_thickness:[ { required: true, message: '请填写厚度', trigger: 'blur' }],
                    original_length:[ { required: true, message: '请填写长度', trigger: 'blur' }],
                    original_cube:[ { required: true, message: '请填写码单立方', trigger: 'blur' }],
                    cube_price:[ { required: true, message: '请填写采购单价', trigger: 'blur' }],
                    original_width_total:[ { required: true, message: '请填写码单总宽', trigger: 'blur' }]
                },
                detailObjectRulesBatch:{},
                last_page: 1,
                total: 0,
                list : [],
                selectRow:[],
                tableCol:[	
                    {colName:"资源状态",colKey:"bale_label",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"捆包号",colKey:"bale_no",colWidth:135,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"供应商",colKey:"supplier",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"品牌",colKey:"brand",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"品名",colKey:"breed",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"等级",colKey:"grade",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"厚度",colKey:"original_thickness",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"长度",colKey:"original_length",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"片数",colKey:"pieces",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"层数",colKey:"layer_number",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"总宽度",colKey:"original_width_total",colWidth:80,isSetWidth:true,isCanClick:true,isShow:true,isHideShowClickImg:true,isHideCanClickColor:true},
                    {colName:"码单立方",colKey:"original_cube",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"销售方数",colKey:"sales_cube",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"销售总宽",colKey:"sales_width_total",colWidth:80,isSetWidth:true,isCanClick:true,isShow:true,isHideShowClickImg:true,isHideCanClickColor:true},
                    {colName:"采购单价",colKey:"cube_price",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"费用单价",colKey:"cost",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"成本单价",colKey:"cost_price",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"合同号",colKey:"contract_no",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"挂牌价",colKey:"sales_price",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"提单号",colKey:"bill_lading_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"货柜号",colKey:"container_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"仓库",colKey:"warehouse",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"入库时间",colKey:"inbound_time",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"产品图片",colKey:"thumbnail",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isStockImg:true,isColor:true},
                    {colName:"关联文件",colKey:"files",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isRelativeFile:true,isColor:true},
                    {colName:"货权单位",colKey:"opening_company",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"选色",colKey:"color",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"单片均宽",colKey:"avg_width",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"选色",colKey:"color",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"榉木总宽",colKey:"zel_total_width",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"宽度",colKey:"one_width",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"重量",colKey:"weight",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"备注",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true}
                ],
                totalObj:{},
                widthObj:{
                    id:"",
                    widthList:[],
                    isCanEdit:false,
                    widthType:2,//2.码单 3.销售
                },
                dialogVisibleWidth:false,
                dialogVisibleWidthA:false,
                filterDialogVisible:false,
                filter:"",
                fields:"",
                boardAmericaType:localStorage.dw_erp_board.indexOf("board-america")!=-1?true:false,
                boardZelkovaType:localStorage.dw_erp_board.indexOf("board-america")!=-1?true:false,
                boardAfricaType:localStorage.dw_erp_board.indexOf("board-africa")!=-1?true:false,
                categoryRawType:localStorage.dw_erp_category.indexOf("raw")!=-1?true:false,
                nationalStandardType:localStorage.dw_erp_board.indexOf("board-africa")!=-1?true:false,
                active : "",
                downloadName:"",
                downloadUCode:"",
                checkoutDialog:false,//入库确认框
                form_params:{
                    warehouse_id:[],
                    inbound_time:new Date(),
                    storage_location_id:''
                },
                locationList:[],
                businessRelation: false,
                businessRelationForm: this.$cloneJson(initBusinessRelationForm),
                feeOutFormRlues: {
                    // fee_date: [{required: true, message: '请填写日期', trigger: 'blur'}],
                    // order_id: [{required: true, message: '请选择销售单号', trigger: 'blur'}],
                    fee_id: [{required: true, message: '请选择费用名称', trigger: 'blur'}],
                    payee: [{required: true, message: '请填写收款人', trigger: 'blur'}],
                    amount: [{required: true, message: '请填写金额', trigger: 'blur'}],
                    is_invoice: [{required: true, message: '请选择是否开票', trigger: 'blur'}],
                },
                outFeeSelect: [],
                fee_list:[],
                isCanEditTotalWidth:false,
                saleDialogVisibleWidth:false,
                saleDialogVisibleWidthA:false,
                isSaleCanEditTotalWidth:false,
                formDetail:{},
                selectCube:0.0000,
                downLoadFileDialog:false,
                downFilesList:[],
                widthSaleInventoryId:"",
                isCanWidthEdit:false,
                widthObj:{
                    id:"",
                    widthList:[],
                    widthType:2,//2.码单 3.销售
                },
                ispost:true,
                isHidePer:false,
                issetper:false,
                action:'',
            }
        },
        created(){
            this.getSelectList('breed');
            this.getSelectList('brand');
            this.getSelectList('grade');
            this.getSelectList('supplier');
            this.getSelectList('color');
            this.getSelectList('attribute');
            this.getSelectList('opencompany');
            this.purchase_id=sessionStorage.FINISHED_PRODUCT_DETAILS_ID;
            sessionStorage.removeItem("FINISHED_PRODUCT_DETAILS_ID")
            this.typeBale=sessionStorage.DEMU_ERP_PURCHASE_CONTRACT_TYPE;
            sessionStorage.removeItem("DEMU_ERP_PURCHASE_CONTRACT_TYPE")
            this.getDetailList()
        },
        methods:{
            inStockWarehouse(e){
                this.postFunc("/erp/warehouse.location.select",{warehouse_id:e},res=>{
                    this.form_params.storage_location_id = "";
                    this.locationList = res.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getSelectTranslateDetailList(target){
                this.$getSelectTranslateDetailList(target,this.params).then(res=>{
                    this.selectMapC[target]=res.data.data;
                })
            },
            filterConfirm(){
                this.getDetailList()
            },
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            addWidthT(){
                this.widthObj.widthList.push(null)
            },
            delWidthT(ind){
                 this.widthObj.widthList.forEach((item,index)=>{
                    if(index==ind){
                        this.widthObj.widthList.splice(index,1)
                    }
                 })
            },
            widthEditT(){
                let obj = new Object();
                obj.id=this.widthObj.id;
                if(this.widthObj.widthType==2){
                    obj.width=this.widthObj.widthList;
                }else{
                    obj.sales_width=this.widthObj.widthList;
                }
                this.postFunc("/erp/purchase.bales.update.width",obj,()=>{
                    this.tip('修改成功','success');
                    this.dialogVisibleWidth=false;
                    this.getDetailList()
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            relativeFile(obj){
                this.downLoadFileDialog = !this.downLoadFileDialog;
                if(obj.files!=null){
                    this.downFilesList = obj.files;
                }else{
                    this.downFilesList = '';
                }
            },
            //图片上传点击
            bacthUpImg(){
                if(this.selectRow.length<1){
                    this.tip("请选择数据","warning")
                }else{
                    let arr = new Array();
                    this.selectRow.forEach(item=>{
                        arr.push(item.id)
                    })
                    this.upImgObj.kid = arr;
                    if(this.selectRow.length == 1){
                        this.upImagesList = Array.isArray(this.selectRow[0].images)?JSON.parse(JSON.stringify(this.selectRow[0].images)):[];
                    }
                    this.dialogVisibleImg = true;
                    this.isUpImg = 1;
                }
            },
            //图片上传确认
            saveImgs(){
                this.$confirm('是否确认上传?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.upImgObj.images = this.upImagesList;
                    this.postFuncLoading("/erp/inventory.upload.images",this.upImgObj,()=>{
                        this.tip('上传成功','success');
                        this.dialogVisibleImg = false;
                        this.getDetailList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            //图片上传里面图片删除
            upImgRemove(url){
                this.upImagesList.forEach((item,index)=>{
                    if(item == url){
                        this.upImagesList.splice(index,1)
                    }
                })
            },
            upFileRemove(url){
                this.upFileList.forEach((item,index)=>{
                    if(item.url == url){
                        this.upFileList.splice(index,1)
                    }
                })
            },
            bacthUpFile(){
                if(this.selectRow.length<1){
                    this.tip("请选择数据","warning")
                }else{
                    let arr = new Array();
                    this.selectRow.forEach(item=>{
                        arr.push(item.id)
                    })
                    this.upFileObj.kid = arr;
                    if(this.selectRow.length == 1){
                        this.upFileList = Array.isArray(this.selectRow[0].files)?JSON.parse(JSON.stringify(this.selectRow[0].files)):[];
                    }
                    this.dialogVisibleFile = true;
                    this.isUpImg = 2;
                }
            },
            saveFile(){
                this.$confirm('是否确认上传?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.upFileObj.files = this.upFileList;
                    this.postFuncLoading("/erp/inventory.upload.files",this.upFileObj,()=>{
                        this.tip('上传成功','success');
                        this.dialogVisibleFile = false;
                        this.getDetailList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            backList(){
                this.$root.$children[0].$children[0].showTab({
                    label: "组装拆卸",
                    name: "组装拆卸",
                    content: "warehouseAssembly",
                });
            },
            reset(){
                this.params=this.resetSearch(this.params)
                this.getDetailList();
            },
            batchEdit(){
                if(this.selectRow.length<1){
                    this.tip("请选择数据","warning")
                }else{
                    this.batchEditType=3;
                    this.detailType=3;
                    this.dialogVisible=true;
                }
            },
            batchDel(){
                if(this.selectRow.length<1){
                    this.tip("请选择数据","warning")
                }else{
                    let arr = new Array();
                    this.selectRow.forEach(item=>{
                        arr.push(item.id)
                    })
                    this.getTableDelete(arr)
                }
            },
            outFeeChange(e){
                this.outFeeSelect.forEach(item=>{
                    if(item.id==e){
                        this.businessRelationForm.fee_name = item.name;
                    }
                })
            },
            //获取费用名称
            outFeeSelectFunc(){
                this.postFunc("/erp/purchase.cost.type",{},res=>{
                    this.outFeeSelect=res.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            //关联加工费用
            openbusinessRelation(){
                if(this.selectRow.length<1){
                    this.tip("请选择数据","warning")
                }
                // else if(this.selectRow.length>1){
                //     this.tip("请选择单条数据数据","warning")
                // }
                else{
                    this.businessRelation = true;
                    this.businessRelationForm.fee_date = new Date();
                }
            },
            //关联加工费用确认
            newOutFee(){
                for(let key in this.businessRelationForm){
                    if(this.businessRelationForm[key]==""){
                        if(key=="remark"){
                            this.pl(key)
                        }else{
                            this.tip("请填写完整信息","warning")
                            return;
                        }
                    }
                }
                let arr = new Array();
                this.selectRow.forEach(item=>{
                    arr.push(item.id)
                })
                this.businessRelationForm.inventory_ids = arr;
                let time = this.businessRelationForm.fee_date;
                this.businessRelationForm.fee_date=this.formatTimeZero(this.businessRelationForm.fee_date);
                this.businessRelationForm.id = this.purchase_id;
                // this.postFuncLoading("/erp/translate.detail.addfee",this.businessRelationForm,()=>{
                //     this.tip('添加成功!','success');
                //     this.businessRelation=false;
                //     this.getDetailList()
                // },error=>{
                //     this.tip(error.data.message,"warning")
                // })
                if(this.action!=''){
                    this.businessRelationForm.action = this.action;
                }
                const loading = this.$loading({
                    lock: true,//lock的修改符--默认是false
                    text: 'Loading',//显示在加载图标下方的加载文案
                    spinner: 'el-icon-loading',//自定义加载图标类名
                    background: 'rgba(0, 0, 0, 0.7)',//遮罩层颜色
                    target: document.querySelector('#table')//loadin覆盖的dom元素节点
                })
                this.$axios.post("/erp/translate.detail.addfee",this.businessRelationForm).then((response) => {
                    loading.close();
                    if(response.data.code == 0){
                        this.tip('添加成功!','success');
                        this.businessRelation=false;
                        this.getDetailList()
                    }
                    if(response.data.code == 1300){
                        this.businessRelationForm.fee_date = time;
                        this.tip(response.data.message,"warning")
                    }
                    if(response.data.code == 400){
                        this.businessRelationForm.fee_date = time;
                        this.openConfirm();
                    }   
                }).catch((error) => {
                    window.console.log(error);
                })
            },
            openConfirm(){
                this.$confirm('已有销售单锁定翻包明细,继续会影响销售利润,是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.action = 'Y';
                    this.newOutFee();
                }).catch(()=>{
                    
                });
            },
            //确认入库
            confirmReceiptOpen(){
                if(this.selectRow.length<1){
                    this.tip("请选择数据","warning")
                }else{
                    this.form_params.warehouse_id = this.selectMap.warehouse.length>0?this.selectMap.warehouse[0].id:'';
                    if(this.form_params.warehouse_id){
                        this.inStockWarehouse(this.form_params.warehouse_id);
                    }
                    this.checkoutDialog  = true;
                }
            },
            //确认入库
            transferConfirm(){
                this.$confirm('是否确认入库?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {                  
                    let arr = new Array();
                    this.selectRow.forEach(item=>{
                        arr.push(item.id)
                    })
                    this.form_params.ids = arr;
                    this.locationList.forEach(item=>{
                        if(item.id == this.form_params.storage_location_id){
                            this.form_params.storage_location = item.name;
                        }
                    })
                    this.form_params.inbound_time = parseInt(this.form_params.inbound_time.getTime()/1000);
                    this.postFuncLoading("/erp/translate.instock.confirm",this.form_params,()=>{
                        this.tip('入库成功','success');
                        this.checkoutDialog=false;
                        this.getDetailList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                        this.form_params.inbound_time = new Date();
                    })
                }).catch(()=>{});
            },
            //打印标签
            printTip(){
                if(this.selectRow.length<1){
                    this.tip("请选择打印数据","warning")
                }else{
                    let arr = new Array();
                    this.selectRow.forEach(item=>{
                        arr.push(item.id)
                    })
                    let url = "/labelPrint?ids=" + arr+"&field="+this.params.field+"&sort="+this.params.sort;
                    window.open(url);
                }
            },
            delWidth(ind){
                 this.detailObject.width.forEach((item,index)=>{
                     if(index==ind){
                         this.detailObject.width.splice(index,1)
                     }
                 })
            },
            addWidth(){
                this.detailObject.width.push(null)
            },
            //添加单条数据
            openAdd(){
                this.detailType=2;
                if(this.boardAmericaType==true&&this.nationalStandardType==true){
                    this.detailObject.category =1;
                }else if(this.boardAmericaType==true&&this.nationalStandardType==false){
                    this.detailObject.category =1;
                }else if(this.boardAmericaType==false&&this.nationalStandardType==true){
                    this.detailObject.category =2;
                }
                this.dialogVisible = !this.dialogVisible;
            // detailObject.purchase_id=purchase_id;dialogVisible = !dialogVisible;detailType=2;detailObject.category=info.category;detailObject.contract_no=info.contract_no;detailObject.contract_time=parseInt(info.contract_time+'000');detailObject.supplier_id=info.supplier_id;
            },
            add(){
                this.$refs["detailObjectForm"].validate((valid) => {
                    if (valid) {
                        // let contract_time = this.detailObject.contract_time;
                        // let expected_storage_time = this.detailObject.expected_storage_time;
                        // let expected_arrival_time = this.detailObject.expected_arrival_time;
                        // this.detailObject.contract_time=this.formatTimeZero(this.detailObject.contract_time);
                        // this.detailObject.expected_storage_time=this.formatTimeZero(this.detailObject.expected_storage_time);
                        // this.detailObject.expected_arrival_time=this.formatTimeZero(this.detailObject.expected_arrival_time);
                        // this.detailObject.wood_type = this.info.wood_type;
                        if(this.detailType==2){
                            this.detailObject.original_cube = Number(this.detailObject.original_cube)
                            this.detailObject.order_id = this.purchase_id;
                            if(this.detailObject.category==1){
                                delete this.detailObject.original_width_total;
                                delete this.detailObject.sales_width_total;
                                delete this.detailObject.width;
                                delete this.detailObject.sales_width_total;
                            }else if(this.detailObject.category==2){
                                delete this.detailObject.pieces; 
                                delete this.detailObject.check_cube; 
                            }
                            this.postFuncLoading("/erp/translate.detail.add",this.detailObject,()=>{
                                    this.dialogVisible = false;
                                    this.tip('新增成功','success');
                                    this.getDetailList();
                                },error=>{
                                    this.tip(error.data.message,"warning")
                                },()=>{
                                    // this.detailObject.contract_time = contract_time;
                                    // this.detailObject.expected_storage_time = expected_storage_time;
                                    // this.detailObject.expected_arrival_time = expected_arrival_time;
                                })
                        }else{
                            if(this.batchEditType==3){
                                let arr = new Array();
                                this.selectRow.forEach(item=>{
                                    arr.push(item.id)
                                })
                                this.detailObject.id=arr;
                                this.postFuncLoading("/erp/inventory.update",this.detailObject,()=>{
                                    this.dialogVisible = false;
                                    this.tip('修改成功','success');
                                    this.getDetailList();
                                },error=>{
                                    this.tip(error.data.message,"warning")
                                 })
                                return
                            }
                            this.postFuncLoading("/erp/inventory.update.one",this.detailObject,()=>{
                                this.dialogVisible = false;
                                this.tip('修改成功','success');
                                this.getDetailList();
                            },error=>{
                                // this.detailObject.contract_time = contract_time;
                                // this.detailObject.expected_storage_time = expected_storage_time;
                                // this.detailObject.expected_arrival_time = expected_arrival_time;
                                this.tip(error.data.message,"warning")
                            },()=>{
                                // this.detailObject.contract_time = contract_time;
                                // this.detailObject.expected_storage_time = expected_storage_time;
                                // this.detailObject.expected_arrival_time = expected_arrival_time;
                            })
                        }
                    } else {
                        return false;
                    }
                });
            },
            getDetailList(){
                this.tableColCopy = this.$deepClone(this.tableCol);
                this.params.id=this.purchase_id;
                this.tableLoading = true;
                this.params.inbound_time_start=this.formatTimeZero(this.inbound_time_start);
                this.params.inbound_time_end=this.formatTimeZero(this.inbound_time_end);
                this.$postColumnList("/erp/translate.detail.list",this.params,res=>{
                    this.last_page=parseInt(res.data.data.list.last_page);
                    // this.params.page=parseInt(res.data.data.list.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.list.total);
                    this.totalObj=res.data.data.total;
                    this.list=res.data.data.list.data;
                    this.info=res.data.data.info;
                    this.list.forEach((item,index)=>{
                        if(item.bale_label=='已入库'){
                            item.isDelete = false;
                            item.isEdit = false;
                        }else{
                            item.isDelete = true;
                            item.isEdit = true;
                        }
                        // this.list[index].plate_ruler=this.keepLimit(item.plate_ruler)
                        if(item.inbound_time!=0){
                            this.list[index].inbound_time = this.formatTime(item.inbound_time+"000")
                        }else{
                            this.list[index].inbound_time = "";
                        }
                        // this.list[index].width_total=parseInt(item.width_total)
                    })
                    this.filter = res.data.data.column;
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        // this.pl((this.fields.indexOf(","+item.colKey+",")!=-1)+"  "+item.colKey)
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                        if(item.colKey=="original_thickness"){
                            if(this.fields.indexOf(",thickness,")!=-1){
                                item.isShow=true;
                            }
                        }
                        if(item.colKey=="original_width_total"){
                            if(this.fields.indexOf(",width_total,")!=-1){
                                item.isShow=true;
                            }
                        }
                        if(item.colKey=="original_cube"){
                            if(this.fields.indexOf(",cube,")!=-1){
                                item.isShow=true;
                            }
                        }
                        if(item.colKey=="original_length"){
                            if(this.fields.indexOf(",length,")!=-1){
                                item.isShow=true;
                            }
                        }
                        if(item.colKey=="status_text"){
                            if(this.fields.indexOf(",status,")!=-1){
                                item.isShow=true;
                            }
                        }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getPage(obj){
                this.params.page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
            rowClick(obj){
                if (['original_width_total', 'sales_width_total'].includes(obj.name)) {
                    this.widthSaleInventoryId = this.widthObj.id = obj.id;
                    if (obj.name === "original_width_total") {
                        this.widthObj.widthType = 2;
                        this.widthObj.widthList = obj.row.width;
                        this.isHidePer = true;
                        this.issetper = false;
                    } else {
                        this.widthObj.widthType = 3;
                        this.widthObj.widthList = obj.row.sales_width;
                        this.isHidePer = false;
                        this.issetper = true;
                    }
                    this.isCanWidthEdit = obj.row.isEdit;
                    this.dialogVisibleWidth = true;
                }
                // this.dialogVisibleWidth=true;
                // this.list.forEach(item=>{
                //     if(item.id==obj.id){
                //         this.widthObj.id=item.id
                //         if(obj.name=="width_total"){
                //             this.widthObj.widthList=item.width;
                //             if(item.isEdit==1){
                //                 this.widthObj.isCanEdit=true;
                //             }else{
                //                 this.widthObj.isCanEdit=false;
                //             }
                //         }
                //     }
                // })
            },
            getTableDelete(id){
                this.$confirm('是否删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
                    let arr = new Array();
                    if(typeof(id)=="number"){
                        arr.push(id)
                    }else{
                        arr=id;
                    }
                    this.postFuncLoading("/erp/translate.detail.delete",{order_id:this.purchase_id,ids:arr},()=>{
                        this.tip('删除成功','success');
                        this.getDetailList();
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            getTableSee(id){
                this.pl(id)
            },
            getTableEdit(id,row){
                this.detailType=3;
                this.batchEditType=2;
                this.formDetail =this.$deepClone(row);
                this.detailObject=this.formDetail;
                this.dialogVisible=true;
            },
            getRow(row){
                this.selectRow=row;
                let number = 0;
                this.selectRow.forEach(item=>{
                    number += Number(item.original_cube)
                })
                this.selectCube = this.keepLimit(number)
            },
            //点击总宽度
            widthClick(){
                this.widthList = JSON.parse(JSON.stringify(this.detailObject.width));
                this.dialogVisibleWidthA=true;
                this.isCanEditTotalWidth=true;
                this.isCanEditTotalWidth=!this.isCanEdit?true:false;
                // transferType==1?isCanEditTotalWidth=true:(scope.$index==0&&upodateType==2&&!isCanEdit)||(scope.$index==1&&upodateType==3&&!isCanEdit)?isCanEditTotalWidth=true:isCanEditTotalWidth=false;
            },
            //点击销售总宽
            salesWidthClick(){
                this.widthList = JSON.parse(JSON.stringify(this.detailObject.sales_width));
                this.saleDialogVisibleWidthA=true;
                this.isSaleCanEditTotalWidth=true;
                this.isSaleCanEditTotalWidth=!this.isCanEdit?true:false;
            },
             //总宽度返回
             widthReturn(res){
                this.detailObject.width=res;
                this.calculationTotalWidth();
                this.calculationCube();
            },
            // 返回后总宽度计算
            calculationTotalWidth(){
                let total = "";
                let countWidth = "";
                let layer_number = "";
                this.detailObject.width.forEach((item,index)=>{
                    if(this.sameType == 1){
                        if(item.width_other!=undefined){
                            countWidth = item.width_other;
                        }
                        layer_number = item.layer_number;
                        total += !!item.width&&item.width.length>0?item.width.reduce((prev,next)=> Number(prev)+Number(next)):""
                        total += !!item.width&&item.width.length>0?",":"";
                    }else{
                        // let width_other = JSON.parse(JSON.stringify(item.width_other));
                        // if(item.layer_number){//均宽余数有数据时，总宽度=（宽度明细合计/输入宽度个数）*层数+均宽余数、
                            let layer_number = JSON.parse(JSON.stringify(item.layer_number));
                            if(item.width_other==''||item.width_other==undefined){
                                total += !!item.width&&item.width.length>0?this.keepLimit(item.width.reduce((prev,next)=>this.keepLimit( Number(prev)+Number(next)))):"";
                                total += !!item.width&&item.width.length>0?",":"";
                            }else{//均宽余数有数据时，总宽度=（宽度明细合计/输入宽度个数）*层数+均宽余数
                                if(layer_number!=''){
                                    total += !!item.width&&item.width.length>0?
                                    this.rounding(this.$bc_add(this.$bc_mul(this.$bc_div(this.keepLimit(item.width.reduce((prev,next)=>this.keepLimit( Number(prev)+Number(next)))),item.width.length),item.layer_number),item.width_other))
                                    :"";
                                    total += !!item.width&&item.width.length>0?",":"";
                                }else{
                                    total = item.width_other;
                                    total += !!item.width&&item.width.length>0?",":"";
                                }
                            }
                        // }else{
                            //     total += !!item.width&&item.width.length>0?this.keepLimit(item.width.reduce((prev,next)=>this.keepLimit( Number(prev)+Number(next)))):"";
                        //     total += !!item.width&&item.width.length>0?",":"";
                        // }
                    }
                            // if(item.layer_number){
                })
                if(this.sameType == 1){
                    if(layer_number==0){
                        total = String(this.keepLimit(total.substring(0,total.length-1)));
                    }else{
                        if(countWidth){
                            total = String(this.keepLimit(total.substring(0,total.length-1)/countWidth*(layer_number?layer_number:1)));
                        }else{
                            total = String(this.keepLimit(total.substring(0,total.length-1)));
                        }
                    }
                }else{
                    total = String((total.substring(0,total.length-1)));
                }
                this.detailObject.original_width_total = total;
            },
            //返回码单方数计算
            calculationCube(){
                if(this.detailObject.original_width_total){
                    let arr = this.detailObject.width;
                    let newThickness = arr.map(a=>{
                        return a.thickness//厚度
                    })
                    let newLength = arr.map(a=>{
                        return a.length//长度
                    })
                    //码单立方
                    let newArr = arr.map(a=>{
                        return Number(a.cube)
                    })
                    let newCube = newArr.reduce(function(a, b){
                        if(b){
                            return a + b; 
                        }else{
                            return a
                        }
                    }, 0); 
                    //层数 
                    let layer_numberArr = arr.map(a=>{
                        return Number(a.layer_number)
                    })
                    let newlayer_number = layer_numberArr.reduce(function(a, b){
                        if(b){
                            return a + b; 
                        }else{
                            return a
                        }
                    }, 0); 
                    //片数
                    let piecesArr = arr.map(a=>{
                        return Number(a.pieces)
                    })
                    let newpieces = piecesArr.reduce(function(a, b){
                        if(b){
                            return a + b; 
                        }else{
                            return a
                        }
                    }, 0);
                    this.detailObject.original_thickness = String(newThickness);//厚度
                    this.detailObject.original_length = String(newLength);//长度
                    this.detailObject.original_cube = this.keepLimit(newCube);//，码单立方
                    // this.form_params.in.detail[formNumber].layer_number = newlayer_number;//层数
                    // this.form_params.in.detail[formNumber].pieces = newpieces;//片数
                }else{
                    let cal_cube = 0;
                    let thickness = this.detailObject.original_thickness.split(",");
                    let length = this.detailObject.original_length.split(",");
                    let widthT = this.detailObject.original_width_total.split(",");
                    widthT.forEach((item,index)=>{
                            cal_cube += (Number(thickness[index])/100)*length[index]*(Number(widthT[index])/100)//码单立方计算
                    })
                    this.detailObject.original_cube = this.keepLimit(cal_cube);//，码单立方
                }
                // if(this.form_params.in.detail[formNumber].sales_width_total){
                //     let salesArr = this.form_params.in.detail[formNumber].sales_width;
                //     let newThickness = salesArr.map(a=>{
                //         return a.thickness//厚度
                //     })
                //     let newLength = salesArr.map(a=>{
                //         return a.length//长度
                //     })
                //     //码单立方
                //     let newArr = salesArr.map(a=>{
                //         return Number(a.cube)
                //     })
                //     let newCube = newArr.reduce(function(a, b){
                //         if(b){
                //             return a + b; 
                //         }else{
                //             return a
                //         }
                //     }, 0); 
                //     //层数 
                //     let layer_numberArr = salesArr.map(a=>{
                //         return Number(a.layer_number)
                //     })
                //     let newlayer_number = layer_numberArr.reduce(function(a, b){
                //         if(b){
                //             return a + b; 
                //         }else{
                //             return a
                //         }
                //     }, 0); 
                //     //片数
                //     let piecesArr = salesArr.map(a=>{
                //         return Number(a.pieces)
                //     })
                //     let newpieces = piecesArr.reduce(function(a, b){
                //         if(b){
                //             return a + b; 
                //         }else{
                //             return a
                //         }
                //     }, 0);
                //     this.form_params.in.detail[formNumber].original_thickness = String(newThickness);//厚度
                //     this.form_params.in.detail[formNumber].original_length = String(newLength);//长度
                //     this.form_params.in.detail[formNumber].sales_cube = this.keepLimit(newCube);//，码单立方
                //     // this.form_params.in.detail[formNumber].layer_number = newlayer_number;//层数
                //     // this.form_params.in.detail[formNumber].pieces = newpieces;//片数
                // }
            },
            //销售总宽度返回
            saleWidthReturn(res){
                this.detailObject.sales_width=res;
                this.calculationTotalSalesWidth();
                this.calculationSalesCube();
            },
            // 返回后总宽度计算
            calculationTotalSalesWidth(){
                let total = "";
                let countWidth = "";
                let layer_number = "";
                this.detailObject.sales_width.forEach((item,index)=>{
                    if(this.sameType == 1){
                        if(item.width_other!=undefined){
                            countWidth = item.width_other;
                        }
                        layer_number = item.layer_number;
                        total += !!item.width&&item.width.length>0?item.width.reduce((prev,next)=> Number(prev)+Number(next)):""
                        total += !!item.width&&item.width.length>0?",":"";
                    }else{
                        // let width_other = JSON.parse(JSON.stringify(item.width_other));
                        // if(item.layer_number){//均宽余数有数据时，总宽度=（宽度明细合计/输入宽度个数）*层数+均宽余数、
                            let layer_number = JSON.parse(JSON.stringify(item.layer_number));
                            if(item.width_other==''||item.width_other==undefined){
                                total += !!item.width&&item.width.length>0?this.keepLimit(item.width.reduce((prev,next)=>this.keepLimit( Number(prev)+Number(next)))):"";
                                total += !!item.width&&item.width.length>0?",":"";
                            }else{//均宽余数有数据时，总宽度=（宽度明细合计/输入宽度个数）*层数+均宽余数
                                if(layer_number!=''){
                                    total += !!item.width&&item.width.length>0?
                                    this.rounding(this.$bc_add(this.$bc_mul(this.$bc_div(this.keepLimit(item.width.reduce((prev,next)=>this.keepLimit( Number(prev)+Number(next)))),item.width.length),item.layer_number),item.width_other))
                                    :"";
                                    total += !!item.width&&item.width.length>0?",":"";
                                }else{
                                    total = item.width_other;
                                    total += !!item.width&&item.width.length>0?",":"";
                                }
                            }
                        // }else{
                            //     total += !!item.width&&item.width.length>0?this.keepLimit(item.width.reduce((prev,next)=>this.keepLimit( Number(prev)+Number(next)))):"";
                        //     total += !!item.width&&item.width.length>0?",":"";
                        // }
                    }
                            // if(item.layer_number){
                })
                if(this.sameType == 1){
                    if(layer_number==0){
                        total = String(this.keepLimit(total.substring(0,total.length-1)));
                    }else{
                        if(countWidth){
                            total = String(this.keepLimit(total.substring(0,total.length-1)/countWidth*(layer_number?layer_number:1)));
                        }else{
                            total = String(this.keepLimit(total.substring(0,total.length-1)));
                        }
                    }
                }else{
                    total = String((total.substring(0,total.length-1)));
                }
                this.detailObject.sales_width_total = total;
            },
            //返回码单方数计算
            calculationSalesCube(){
                if(this.detailObject.sales_width_total){
                    let salesArr = this.detailObject.sales_width;
                    //码单立方
                    let newArr = salesArr.map(a=>{
                        return Number(a.cube)
                    })
                    let newCube = newArr.reduce(function(a, b){
                        if(b){
                            return a + b; 
                        }else{
                            return a
                        }
                    }, 0); 
                    //层数 
                    let layer_numberArr = salesArr.map(a=>{
                        return Number(a.layer_number)
                    })
                    let newlayer_number = layer_numberArr.reduce(function(a, b){
                        if(b){
                            return a + b; 
                        }else{
                            return a
                        }
                    }, 0); 
                    //片数
                    let piecesArr = salesArr.map(a=>{
                        return Number(a.pieces)
                    })
                    let newpieces = piecesArr.reduce(function(a, b){
                        if(b){
                            return a + b; 
                        }else{
                            return a
                        }
                    }, 0);
                    this.detailObject.sales_cube = this.keepLimit(newCube);//销售立方
                    // this.form_params.in.detail[formNumber].layer_number = newlayer_number;//层数
                    // this.form_params.in.detail[formNumber].pieces = newpieces;//片数
                }
            },
            excelExport(){
                this.params.id=this.purchase_id;
                this.$exportExecl("/erp/translate.details.export","翻包明细",this.params)
            },
            handleSuccess(res) {
                this.file_url = res.data.base_url;
				this.$refs.upload_path.clearFiles();
                this.tip('文件上传成功', 'success');
                //this.importFile();
            },
            //文件导入
            handleSuccessB(res) {
                if(this.isUpImg == 1){
                    this.upImagesList.push(res.data.base_url)
                }else if(this.isUpImg == 2){
                    let obj = new Object();
                    obj.url = res.data.base_url;
                    obj.name = res.data.filename.substring(res.data.filename.lastIndexOf("/")+1,res.data.filename.length)
                    this.upFileList.push(obj)
                }else{
                    this.file_url = res.data.base_url;
                }
                this.$refs.upload_path.clearFiles();
                this.tip('文件上传成功', 'success');
                //this.importFile();
            },
            handleImagesSuccess(file){
                this.upImagesList.push(file.data.base_url);
            },
            beforeUpload(file) {
                this.file = file;
                return this.getOss();
            },
            openimport(){
                this.active = this.boardAmericaType?1: this.boardAfricaType?3:this.boardZelkovaType?2:this.nationalStandardType?5:this.categoryRawType?4:this.nationalStandardType?5:"";
                this.downloadName=this.boardAmericaType?"北美材成品码单":this.boardZelkovaType?"榉木码单模板":this.boardAfricaType?"非洲材成品码单":this.categoryRawType?"原木码单模板":this.nationalStandardType?"非洲材/国标成品码单":"";
                this.downloadUCode=this.boardAmericaType?"tp_america_stock":this.boardZelkovaType?"pur_zelkova_import":this.boardAfricaType?"tp_africa_stock":this.categoryRawType?"pur_wood_import":this.nationalStandardType?"tp_ds_stock":"";
                // this.downloadUUrl=this.boardAmericaType?"/erp/import.qc.america":this.boardZelkovaType?"/erp/import.qc.zelkova":this.boardAfricaType?"/erp/import.qc.africa":this.categoryRawType?"/erp/import.qc.wood":""
                this.importDialogVisible=true;
            },
            importFile(){
                this.postFuncLoading('/erp/translate.package.import',{id:this.purchase_id,file:this.file_url,code:this.downloadUCode},response=>{
                    if (response.data.code == 0) {
                        this.tip("上传成功","success");
                        // let newArr = this.form_params.in.detail.concat(response.data.data);
                        // newArr.forEach((item,index)=>{
                        //     if(item.bale_no == '' && item.breed_id == '' && item.grade_id == ''){
                        //         newArr.splice(index,1);
                        //     }
                        // })
                        // this.form_params.in.detail = newArr;
                        this.importDialogVisible=false;
                        this.getDetailList();
                    }
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            downTemplete(){
                this.exportTranslateFile(this.downloadUCode,response=>{
                    const content = response.data;
                    const blob = new Blob([content], {type: response.headers['content-type']});
                    const fileName = this.downloadName+this.getDownloadTempleteTime(new Date())+'.xlsx';
                    if ('download' in document.createElement('a')) { // 非IE下载
                        const elink = document.createElement('a');
                        elink.download = fileName;
                        elink.style.display = 'none';
                        elink.href = URL.createObjectURL(blob);
                        document.body.appendChild(elink);
                        elink.click();
                        URL.revokeObjectURL(elink.href); // 释放URL 对象
                        document.body.removeChild(elink);
                    } else { // IE10+下载
                        navigator.msSaveBlob(blob, fileName);
                    }
                })
            },
            getOss(){
                let self = this;
                return new Promise((resolve, reject) =>{
                    window.axios.post(window.oss_url+"/tool/v1/oss.policy.get",{
                        operate_code : "shop-excel"
                    }).then((response) => {
                        if(response.data.code == 0){
                            self.oss = response.data.data;
                            this.upload_data = {
                                name: self.file.name,
                                key : self.oss.dir + "${filename}",
                                policy : self.oss.policy,
                                OSSAccessKeyId : self.oss.accessid,
                                success_action_status : "200",
                                callback : self.oss.callback,
                                signature : self.oss.signature,
                                'Cache-Control' : self.oss.cache_control,
                            }
                            resolve();
                        }
                    }).catch(()=>{
                        reject();
                    })
                })
            }
        },
        watch:{
            "params.page":function(){
                this.getDetailList();
            },
            "params.per_page":function(){
                this.getDetailList();
            },
            "active":function(val){
                if(val==1){
                    this.downloadName="北美材成品码单";
                    this.downloadUCode="tp_america_stock";
                }else if(val==3){
                     this.downloadName="非洲材成品码单";
                    this.downloadUCode="tp_africa_stock";
                }
                else if(val==5){
                     this.downloadName="非洲材/国标成品码单";
                    this.downloadUCode="tp_ds_stock";
                }
            },
            "dialogVisible":function(val){
                if(!val){
                    this.detailObject={
                        category:"",
                        brand_id:"",
                        breed_id:"",
                        grade_id:"",
                        purchase_id:"",
                        contract_no:"",
                        attribute_id:"",
                        color_id:"",
                        supplier_id:"",
                        bill_lading_no:"",
                        container_no:"",
                        bale_no:"",
                        original_thickness:"",
                        original_length:"",
                        pieces:"",//片数 北美材字段
                        original_cube:"",
                        check_cube:"",
                        sales_cube:"",
                        cube_price:"",
                        sales_price:"",
                        original_width_total:0,
                        sales_width_total:0,
                        width:[{
                            cube:'',
                            layer_number: "",
                            length: "",
                            length_formula: "",
                            spec: "",
                            thickness: "",
                            thickness_formula: "",
                            veneer_avg: "",
                            width: [],
                            width_other: "",
                            pieces:'',
                        }],
                        sales_width:[{
                            cube:'',
                            layer_number: "",
                            length: "",
                            length_formula: "",
                            spec: "",
                            thickness: "",
                            thickness_formula: "",
                            veneer_avg: "",
                            width: [],
                            width_other: "",
                            pieces:'',
                        }],
                        remark:"",
                    }
                }
            },
            "dialogVisibleWidth":function(val){
                if(!val){
                    this.widthObj={id:"",widthList:[],widthType:2}
                }
            },
            "businessRelation":function(val){
                if(!val){
                    this.action='';
                    this.businessRelationForm= this.$cloneJson(initBusinessRelationForm)
                }
            },
            "dialogVisibleImg":function(val){
                if(!val){
                    this.isUpImg = 0;
                    this.upImgObj = {kid:[],images:[]}
                    this.upImagesList = [];
                }
            },
            "dialogVisibleFile":function(val){
                if(!val){
                    this.isUpImg = 0;
                    this.upFileObj = {kid:[],files:[]}
                    this.upFileList = [];
                }
            },
            typeBale:function(val){
                this.tableCol = this.tableCol
            }
        }
    }
</script>
